import { Bookmark, BrainCircuit, ClipboardCheck, Database, Home, Megaphone, MessageCircleQuestion, Palette, Rocket, Search, Settings, ShieldCheck, Sparkles, Stethoscope } from "lucide-react";
import { NavLink } from "react-router-dom";
import { cn } from "../../lib/cn";
import { isAdminRole, useAuthStore } from "../../features/auth/authStore";

const navItems = [
  { to: "/home", label: "Home", icon: Home },
  { to: "/questions", label: "Q", icon: MessageCircleQuestion },
  { to: "/deep-dive", label: "Deep", icon: BrainCircuit },
  { to: "/swipe", label: "Swipe", icon: Sparkles },
  { to: "/diagnosis", label: "診断", icon: Stethoscope },
  { to: "/design", label: "デザイン", icon: Palette },
  { to: "/marketing", label: "マーケ", icon: Megaphone },
  { to: "/pre-launch", label: "ローンチ前", icon: ClipboardCheck },
  { to: "/vibe-deploy", label: "Deploy", icon: Rocket },
  { to: "/saved", label: "Saved", icon: Bookmark },
  { to: "/settings", label: "Settings", icon: Settings }
];

const adminNavItems = [
  { to: "/admin/samples", label: "Seed", icon: Database },
  { to: "/admin/settings", label: "Profile", icon: Settings },
  { to: "/admin/research", label: "調査", icon: Search },
  { to: "/admin/cost", label: "Cost", icon: ShieldCheck }
];

export function MobileNav() {
  const role = useAuthStore((state) => state.role);
  const visibleNavItems = isAdminRole(role) ? adminNavItems : navItems;

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-[color:var(--border)] bg-[color:var(--surface)]/94 px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 backdrop-blur lg:hidden">
      <div className={cn("grid gap-1", isAdminRole(role) ? "grid-cols-4" : "grid-cols-5")}>
        {visibleNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex min-h-12 flex-col items-center justify-center gap-1 rounded-card text-[0.7rem] font-semibold transition",
                  isActive ? "bg-[color:var(--surface-raised)] text-[color:var(--text)]" : "text-[color:var(--muted)]"
                )
              }
            >
              <Icon className="h-4 w-4" aria-hidden />
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
